<template>
    <div>
        <b-card-header v-b-toggle.property-information>
            STEP 2 - Property Information
        </b-card-header>
        <b-collapse id="property-information">
            <b-card>
                <b-row>
                    <b-col cols="6">
                        <b-form-group>
                            <label>Developer Listing ID</label>
                            <b-form-input placeholder="Enter Developer Listing ID" v-model="property.developerListingId"></b-form-input>
                        </b-form-group>                        
                    </b-col>
                    <b-col cols="6">
                        <b-form-group>
                            <label>Referring Platform</label>
                            <b-form-input placeholder="Enter Referring Platform" v-model="property.referringPlatform"></b-form-input>
                        </b-form-group>                        
                    </b-col>
                    <b-col cols="12">
                        <b-form-group>
                            <label>Property Address</label>
                            <b-form-input placeholder="Enter Property Address" v-model="property.address"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group>
                            <label>Property City</label>
                            <b-form-input placeholder="Enter Property City" v-model="property.city"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group>
                            <label>Property State</label>
                            <custom-select
                                    v-if="stateOptions.length > 0"
                                    :reduce="option => option.value"
                                    v-model="property.state"
                                    :options="stateOptions"
                                    :clearable="false"
                                    required
                                    cs-label="text"
                                    unique-identifier="value"
                                    aria-placeholder="Select Agent's License State"
                                />
                        </b-form-group>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group>
                            <label>Property Zip</label>
                            <b-form-input placeholder="Enter Property Zip" v-model="property.zip"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card>
        </b-collapse>
    </div>
</template>
<script>

export default {
 name: 'PropertyInformation',
 props: {
    property:{
        type: Object,
        default:{
            address: null,
            state: null,
            zip: null,
            city: null,
            developerListingId: null,
            referringPlatform: null
        }
    },
    states: {
        type: Array,
        default: []
    }
 },
 computed:{
    stateOptions(){
        return this.states;
    }
 }
}
</script>
